import { DriverStep } from '../types/DriverStep'

export const runsheetTourSteps: DriverStep[] = [
  {
    element: '#tab-runsheet-nav',
    popover: {
      title: 'Runsheet',
      description: 'The Runsheet page allows you to view and manage your delivery operations for the day. You can view the runsheets for the day and track the progress of each run.',
    },
  },
  {
    element: '#runsheet-tree-view',
    popover: {
      title: 'Runsheet Tree',
      description: 'The runsheet tree displays the active runsheets and historical runsheets. You can drag and drop the runsheets to the runsheet workspace to view the details.',
    },
  },
  {
    element: '#active-runsheet-tree',
    popover: {
      title: 'Active Runsheets',
      description: 'Active runsheets are the runsheets that are planned and published for current or future date.',
    },
  },
  {
    element: '#historical-runsheet-tree',
    popover: {
      title: 'Historical Runsheets',
      description: 'Historical runsheets are the runsheets that have been closed.',
    },
  },
  {
    element: '#runsheet-widget-dock',
    popover: {
      title: 'Widget Toolbar',
      description: 'This is your widget toolbar. Each widget represents a tool, and you can drag a widget from here and drop it into the workspace to open a tool.',
    },
  },
  {
    element: '#runsheet-workspace',
    popover: {
      title: 'Runsheet Workspace',
      description: 'This is your main workspace. View your runsheets & run operations by dragging the runsheets and runs from the runsheet tree and dropping them here. Use widgets from the toolbar to visualize and analyze your operations. The workspace supports drag-and-drop functionality for easy window management.',
      side: 'top',
      align: 'end',
    },
  },
]
